import { render } from "./FaviconComponent.vue?vue&type=template&id=5bedf3cb"
import script from "./FaviconComponent.vue?vue&type=script&lang=js"
export * from "./FaviconComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__